export const environment = {
  prod: false,
  panel: 'vendor',
  apiBaseUrl: 'https://hq-lawazm.adad.ws',
  filesApiUrl: 'https://hq-lawazm-file.adad.ws/VendorPanel/VendorUploadFiles',
};
